export default __webpack_public_path__ + "static/media/Abdomen.386ef071.svg";